// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"SearchBar_styles_searchWrapper__2rJEs","searchButton":"SearchBar_styles_searchButton__1Vskb"};